import { render, staticRenderFns } from "./AdjuvantTreatment.vue?vue&type=template&id=35e3178f&scoped=true&"
import script from "./AdjuvantTreatment.vue?vue&type=script&lang=js&"
export * from "./AdjuvantTreatment.vue?vue&type=script&lang=js&"
import style0 from "./AdjuvantTreatment.vue?vue&type=style&index=0&id=35e3178f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3178f",
  null
  
)

export default component.exports